import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ValentinoLogo from "./ValentinoLogo.jsx";
import { useSector } from "./SectorContext";

function MainMenu() {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeSector } = useSector();

  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const handleKeyNavigation = (event, path) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleNavigation(path);
    }
  };

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Close the mobile menu when Escape is pressed.
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);

  return (
    <nav className="upper-menu-container" aria-label="Main navigation">
      <div className="logo-wrapper">
        <div
          className="logo"
          role="button"
          tabIndex={0}
          aria-label="Go to homepage"
          onClick={() => handleNavigation("/")}
          onKeyDown={(event) => handleKeyNavigation(event, "/")}
        >
          <ValentinoLogo
            className={`site-logo ${activeSector.colorClass}`}
          />
        </div>
      </div>

      <button
        type="button"
        className={`hamburger-button ${menuOpen ? "is-open" : ""}`}
        onClick={() => setMenuOpen((currentState) => !currentState)}
        aria-expanded={menuOpen}
        aria-controls="main-navigation-links"
        aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </button>

      <div
        id="main-navigation-links"
        className={`upper-menu-wrapper ${menuOpen ? "is-open" : ""}`}
      >
        <div
          className="menu-button"
          role="button"
          tabIndex={0}
          onClick={() => handleNavigation("/")}
          onKeyDown={(event) => handleKeyNavigation(event, "/")}
        >
          HOME
        </div>

        <div
          className="menu-button"
          role="button"
          tabIndex={0}
          onClick={() => handleNavigation("/about")}
          onKeyDown={(event) => handleKeyNavigation(event, "/about")}
        >
          ABOUT
        </div>

        <div
          className="menu-button"
          role="button"
          tabIndex={0}
          onClick={() => handleNavigation("/contact")}
          onKeyDown={(event) => handleKeyNavigation(event, "/contact")}
        >
          START PROJECT
        </div>
      </div>
    </nav>
  );
}

export default MainMenu;